import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import { cn } from '@/Domain/utils/cn';

type Props = {
  title: string;
  description: string;
  Icon?: any;
  bgIconColor?: string;
  className?: string;
};

export const Banner = ({
  Icon,
  title,
  bgIconColor = 'bg-foreground-muted',
  description,
  children,
  className,
}: PropsWithChildren<Props>) => (
  <div
    className={classNames(
      'grid grid-cols-[1fr_auto] items-center rounded-xl border border-border bg-muted p-6 text-foreground',
      className,
    )}
  >
    <div>
      <header className="inline-flex items-center gap-3 mb-2">
        {Icon && (
          <section className={cn('rounded-full p-1', bgIconColor)}>
            {<Icon className="size-3.5 text-background" fill="currentColor" />}
          </section>
        )}
        <p className="font-semibold text-foreground">{title}</p>
      </header>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
    {children}
  </div>
);
